module.exports = __webpack_public_path__ + "fonts/DINPro-CondBold.481d38e7.otf";